import axios from '@/utils/api';

const usersQuery = `
  query {
    codebaseUsers {
      edges {
        node {
          id, 
          firstName, 
          lastName, 
          company, 
          userName, 
          email
        }
      }
    }
  }
`

export default {
  namespaced: true,

  state: {
    users: []
  },

  getters: {
    getUsers (state) {
      return state.users
    }
  },

  actions: {
    async fetchUsers ({ commit, rootState }) {
      const response = await axios.post('/graphql', {
        query: usersQuery
      },
      {
        headers: {
          'Authorization': rootState.auth.authToken
        }
      }
      )

      if (response.status === 200) {
        commit('setUsers', response.data.data.codebaseUsers.edges)
      }
    }
  },

  mutations: {
    setUsers(state, users) {
      state.users = users
    }
  }
}